export enum DocumentEditorActionType {
  // drawer
  OpenDrawer = 'openDrawer',
  CloseDrawer = 'closeDrawer',
  // fold / unfold
  FoldAllSections = 'foldAllSections',
  UnfoldAllSections = 'unfoldAllSections',
  // editor mode
  SetEditorMode = 'setEditorMode',
  // two step actions on content
  RequestTwoStepContentAction = 'requestTwoStepContentAction',
  ClearTwoStepContentAction = 'clearTwoStepContentAction',
  // Document versioning
  Undo = 'undo',
  Redo = 'redo',
  ClearHistory = 'clearHistory',
  ClearNavigationTarget = 'clearNavigationTarget',
  BumpLatestSavedVersion = 'bumpLatestSavedVersion',
  // update meta
  UpdateInfo = 'updateInfo',
  UpdateAdmin = 'updateAdmin',
}
